<template>
    <a-card :bordered="false">
      <a-form-item><a @click="routeBack">&lt;&lt; 返回</a></a-form-item>
      <detail-list title="发卡记录详情" v-if="mdl">
        <detail-list-item term="物流单号">{{ mdl.logisticsNo }}</detail-list-item>
        <detail-list-item term="卡号">{{ mdl.cardNo }}</detail-list-item>
        <detail-list-item term="车号">{{ mdl.vehicleNo }}</detail-list-item>
        <detail-list-item term="收发卡单号">{{ mdl.grantCardNo }}</detail-list-item>
        <detail-list-item term="驾驶员">{{ mdl.driverName }}</detail-list-item>
        <detail-list-item term="状态">{{ mdl.statusName }}</detail-list-item>
        <detail-list-item term="卡类型">{{ mdl.cardTypeName }}</detail-list-item>
     
        <detail-list-item term="收/发卡时间">{{mdl.createTime | formatDate}}</detail-list-item>
        <detail-list-item term="物流状态">{{mdl.logisticsStatusName}}</detail-list-item>
      </detail-list>
    </a-card>
</template>

<script>
import DetailList from '@/components/tools/DetailList'
import Moment from 'moment'
import storage from "@/utils/storage"

const DetailListItem = DetailList.Item
export default {
  components: {
    DetailList,
    DetailListItem
  },
  data () {
    return {
      mdl: null
    }
  },
  mounted () {
    this.initData()
  },
  filters: {
    formatDate (value) {
      return Moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
     
    routeBack(){
      localStorage.setItem('goback', "true");
      this.$router.back(-1)
    },
    initData () {
      let cache = storage.fetch("cache-GrantCardDetail")
      if (cache){
          this.mdl = JSON.parse(cache);
      } 
    }
  }
}
</script>



